<template>
    <v-container fluid>
        <page-header title="Seasons" icon="mdi-calendar">
            <template v-slot:actions>
                <v-btn class="white--text" depressed small color="black" @click="createSeason">
                    <v-icon left small>mdi-plus</v-icon>Create
                </v-btn>
            </template>
            <table-filters :fields="filterFields" :value="filterValues" @apply="applyFilters" />
        </page-header>
        <array-view
            :items="seasons"
            :headers="displayInfo"
            :total-pages="totalPages"
            :page="page"
            :size="size"
            :sort-by="sort.sortBy"
            :sort-desc="sort.sortDesc"
            @onDelete="onDelete"
            @handleClick="handleClick"
            @paginationChange="paginationChange"
            @sortChange="changeSort"
        />
    </v-container>
</template>

<script>
    import seasonService from '@/services/season'
    import ArrayView from '@/components/ArrayView'
    import TableFilters from '@/components/TableFilters'
    import PageHeader from '@/components/PageHeader'
    import listTable from '@/mixins/listTable'

    export default {
        name: 'Season',
        components: { ArrayView, TableFilters, PageHeader },
        mixins: [listTable],
        data: () => {
            return {
                successfullImport: null,
                seasons: [],
                displayInfo: [
                    {
                        text: 'Id',
                        value: 'id'
                    },
                    {
                        text: 'Year',
                        value: 'year'
                    },
                    {
                        text: 'Type',
                        value: 'type'
                    },
                    {
                        text: 'Start Date',
                        value: 'startDate'
                    },
                    {
                        text: 'End Date',
                        value: 'endDate'
                    }
                ],
                tableKey: 'seasons',
                filterFields: [
                    { key: 'name', label: 'Name', type: 'text' },
                    { key: 'year', label: 'Year', type: 'number' },
                    { key: 'type', label: 'Type', type: 'select', items: ['winter', 'summer'] },
                    { key: 'startDate', label: 'Start Date', type: 'dateRange' }
                ],
                showImportDialog: false,
                size: 5,
                totalPages: 0,
                page: 1
            }
        },
        created() {
            this.fetchItems()
        },
        methods: {
            handleClick(action, item) {
                this.$router.push(`/seasons/${item.id}/${action}`)
            },
            onDelete(item, page) {
                seasonService.deleteSeason(item.id).then(() => {
                    this.page = page
                    this.fetchItems()
                })
            },
            createSeason() {
                this.$router.push(`/seasons/create`)
            },
            fetchItems() {
                seasonService.getFilteredSeasons(this.filterQuery, this.page, this.size, this.sort).then(resp => {
                    this.seasons = resp.data.content
                    this.totalPages = resp.data.totalPages
                })
            }
        }
    }
</script>

<style scoped>
.card-title {
    display: flex;
}

.v-list-item {
    min-height: 30px !important;
}

.v-card {
    min-width: 250px;
    position: relative;
}

.header-card {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1%;
}

.header-buttons {
    align-self: center;
}

.edit-button:hover {
    background-color: whitesmoke;
    color: white;
}

.screen-card {
    padding: 4%;
}

.overflow-text {
    max-width: 79%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.pagination {
    justify-content: center;
}
</style>
